import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import BaseLayout from '../layouts/BaseLayout';
import Leads from './Leads';
import Lead from './Lead';
import DocumentPreview from './DocumentPreview';
import IntakeForm from './IntakeForm';
import Agreements from './Agreements';
import Proposals from './Proposals';
import InviteUser from './InviteUser';
import Notifications from './Notifications';
import Profile from './Profile';
import Resources from './Resources';
import BulkEnrichment from './BulkEnrichment';
import Authorization from './Authorization';
import RegisterResult from './Authorization/RegisterResult';
import PasswordReset from './PasswordReset';
import ProspectNowBulkEnrichment from './ProspectNowBulkEnrichment';
import ProspectNowUploadDetails from './ProspectNowBulkEnrichment/ProspectNowUploadDetails';
import { AppliedRoute, AuthenticatedRoute, ProtectedRoute, UnauthenticatedRoute } from '@/components';
import QuickbaseView from './QuickbaseView/QuickbaseView';

const NotFound = () => <div>NotFound</div>;

export const menuItems = [
  {
    name: 'Manage',
    path: '/manage',
    icon: 'dashboard',
    children: [
      {
        component: Leads,
        exact: true,
        name: 'Leads',
        path: '/manage/leads',
        admin: false,
      },
      {
        component: Agreements,
        exact: true,
        name: 'Agreements',
        path: '/manage/agreements',
        admin: true,
      },
      {
        component: Proposals,
        exact: true,
        name: 'Proposals',
        path: '/manage/proposals',
        admin: true,
      },
      {
        component: BulkEnrichment,
        exact: true,
        name: 'Bulk Enrichment',
        path: '/manage/bulk-enrichment',
        admin: true,
      },
      {
        component: ProspectNowBulkEnrichment,
        exact: true,
        name: 'Prospect Now Bulk Enrichment',
        path: '/manage/prospect-now-bulk-enrichment/upload',
        admin: true,
      },
    ],
  },
  {
    name: 'User',
    path: '/user',
    icon: 'user',
    children: [
      {
        component: Notifications,
        exact: true,
        name: 'Notifications',
        path: '/user/notifications',
        admin: false,
      },
      {
        component: Profile,
        exact: true,
        name: 'Profile',
        path: '/user/profile',
        admin: false,
      },
      {
        component: InviteUser,
        exact: true,
        name: 'Invite User',
        path: '/user/invite-user',
        admin: false,
      },
      {
        component: Resources,
        exact: true,
        name: 'Resources',
        path: '/user/resources',
        admin: false,
      },
    ],
  },
];

const manageRegex = '[a-z|-]{1,30}';
const userRegex = '[a-z|-]{1,20}';
const leadIdRegex = '[0-9]{1,10}';

export default ({ authProps }) => (
  <Switch>
    <Route
      exact
      path={`/(manage/${manageRegex}|manage/leads/${leadIdRegex}|
      |manage/leads/${leadIdRegex}/document-preview|
      |manage/prospect-now-bulk-enrichment/upload|
      |manage/prospect-now-bulk-enrichment/upload-details|
      |quickbase-view|
      |user/${userRegex}|document-preview)?`}
      render={(routerProps) => (
        <BaseLayout {...authProps} menuItems={menuItems} routerProps={routerProps}>
          <Switch>
            <Route exact path="/" render={() => <Redirect to="/manage/leads" />} />
            <AuthenticatedRoute exact path="/manage/leads" component={Leads} props={authProps} />
            <AuthenticatedRoute exact path="/manage/leads/:id" component={Lead} props={authProps} />
            <AuthenticatedRoute exact path="/manage/intake-form" component={IntakeForm} props={authProps} />
            <ProtectedRoute
              exact
              path="/manage/agreements"
              component={Agreements}
              props={{ ...authProps, admin: true }}
            />
            <ProtectedRoute
              exact
              path="/manage/proposals"
              component={Proposals}
              props={{ ...authProps, admin: true }}
            />
            <ProtectedRoute
              exact
              path="/manage/bulk-enrichment"
              component={BulkEnrichment}
              props={{ ...authProps, admin: true }}
            />
            <ProtectedRoute
              exact
              path="/manage/prospect-now-bulk-enrichment/upload"
              component={ProspectNowBulkEnrichment}
              props={{ ...authProps, admin: true }}
            />
            <ProtectedRoute
              exact
              path="/manage/prospect-now-bulk-enrichment/upload-details"
              component={ProspectNowUploadDetails}
              props={{ ...authProps, admin: true }}
            />
            <ProtectedRoute exact path="/user/invite-user" component={InviteUser} props={authProps} />
            <AuthenticatedRoute exact path="/user/notifications" component={Notifications} props={authProps} />
            <AuthenticatedRoute exact path="/user/profile" component={Profile} props={authProps} />
            <AuthenticatedRoute exact path="/user/resources" component={Resources} props={authProps} />
            <AuthenticatedRoute exact path="/document-preview" component={DocumentPreview} props={authProps} />
            <AuthenticatedRoute exact path="/quickbase-view" component={QuickbaseView} props={authProps} />
            <AppliedRoute props={authProps} component={NotFound} />
          </Switch>
        </BaseLayout>
      )}
    />
    <AuthenticatedRoute exact path="/signup-result" component={RegisterResult} props={authProps} />
    <UnauthenticatedRoute exact path="/login" component={Authorization} props={authProps} />
    <UnauthenticatedRoute strict path="/signup" component={Authorization} props={authProps} />
    <UnauthenticatedRoute exact path="/password-reset" component={PasswordReset} props={authProps} />
    <AppliedRoute props={authProps} component={NotFound} />
  </Switch>
);
